import { BaseReactComponent } from "@/Common/Components/BaseReactComponent";
import { Locale } from "@/Common/Models/Localization/Locale";
import { GestationalAge } from "@/Patient/Models/ObstetricalFile/GestationalAge";
import { ObstetricalFileControlRenderer } from "../ControlRenderer/ObstetricalFileControlRenderer";

interface IGestationalAgeComponentProps {
    id: string;
    readonly: boolean;
    gestationalAge: GestationalAge;
    onChange: (value: GestationalAge) => void;
    controlRenderer: ObstetricalFileControlRenderer;
    locale?: Locale;
    weekClassName?: string;
    dayClassName?: string;
}

class GestationalAgeComponent extends BaseReactComponent<IGestationalAgeComponentProps> {
    public render(): JSX.Element {
        const controlRender = this.props.controlRenderer;
        if (!controlRender)
            return null;

        return (
            <div className="medicalhistory-inline-textbox">
                <div>
                    {controlRender.renderTextbox({
                        value: this.props.gestationalAge?.NumberOfWeeks,
                        onChange: value => this.props.onChange(new GestationalAge({ ...this.props.gestationalAge, NumberOfWeeks: value })),
                        className: `gestational-age ${this.props.weekClassName ?? ""} ${!this.props.readonly ? "gestational-age-border-style" : ""} gestational-age-week-width`,
                        maxLength: 2,
                        isInteger: true,
                        id: `${this.props.id}_week`
                    })}
                </div>
                {this.shouldDisplayWeekLabel() && (
                    <div>
                        {cacheStore.GetString("WeekAbbrevLabel", null, this.props.locale ?? sessionStore.locale)}
                    </div>
                )}

                {this.shouldDisplayWeekAndDateLabel() && <span>&nbsp;</span>}

                <div>
                    {controlRender.renderTextbox({
                        value: this.props.gestationalAge?.NumberOfDays,
                        onChange: value => this.props.onChange(new GestationalAge({ ...this.props.gestationalAge, NumberOfDays: value })),
                        className: `gestational-age ${this.props.dayClassName ?? ""} ${!this.props.readonly ? "gestational-age-border-style" : ""} gestational-age-day-width`,
                        maxLength: 1,
                        isInteger: true,
                        id: `${this.props.id}_day`
                    })}
                </div>
                {this.shouldDisplayDayLabel() && (
                    <div>
                        {cacheStore.GetString("DayAbbrevLabel", null, this.props.locale ?? sessionStore.locale)}
                    </div>
                )}
            </div>
        );
    }

    private shouldDisplayWeekLabel(): boolean {
        if (!this.props.readonly)
            return true;

        return !IsNullOrWhiteSpace(this.props.gestationalAge?.NumberOfWeeks);
    }

    private shouldDisplayDayLabel(): boolean {
        if (!this.props.readonly)
            return true;

        return !IsNullOrWhiteSpace(this.props.gestationalAge?.NumberOfDays);
    }

    private shouldDisplayWeekAndDateLabel(): boolean {
        return this.shouldDisplayDayLabel() && this.shouldDisplayWeekLabel();
    }
}

export { GestationalAgeComponent };
